import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const useSaveActionItemDetailsFn = (actionItemId: string | number) => {
  return apiClient.get(`${APP_API_URL_V2}fsd/action-item/${actionItemId}/details-pdf`, {
    responseType: 'arraybuffer',
  });
};

export const useSaveActionItemDetailsMutation = () => {
  return useMutation({
    mutationFn: useSaveActionItemDetailsFn,
  });
};
